import { TFunction } from "i18next";
import * as yup from "yup";
import { InferType } from "yup";
import { CATEGORY_TYPES } from "@/domain/category.interface";

const categoryValidationSchema = (t: TFunction) =>
  yup.object().shape({
    type: yup
      .string()
      .required("This field is required")
      .oneOf([...CATEGORY_TYPES], "Invalid type"),
    status: yup
      .string()
      .oneOf(["ACTIVE", "INACTIVE"], "Invalid status")
      .default("ACTIVE"),
    phoneNumber: yup.string().default(""),
    categories: yup
      .array()
      .of(
        yup.object().shape({
          _id: yup.string().optional(),
          icon: yup.string().default(""),
          hexaColor: yup.string().default(""),
          textColor: yup.string().default(""),
          status: yup
            .string()
            .oneOf(["ACTIVE", "INACTIVE"], "Invalid status")
            .default("ACTIVE"),
          languages: yup
            .array()
            .of(
              yup.object().shape({
                language: yup.string().required("Language is required"),
                name: yup
                  .string()
                  .required("Name is required")
                  .max(200, t("validations.max_length", { count: 200 })),
                description: yup.string().default(""),
              })
            )
            .min(1, "Add at least one language")
            .required(),
        })
      )
      .min(1, "Add at least one item")
      .required(),
  });

export type CategoryFormData = InferType<
  ReturnType<typeof categoryValidationSchema>
>;

export default categoryValidationSchema;
